import { forEach } from "lodash";

export class HubsPage {
    hubHeightMap: Map<string, number>;
    hubBeforeHeightMap: Map<string, number>;

    constructor() {
        const hubIds = ["hub-0", "hub-1", "hub-2", "hub-3", "hub-4", "hub-5", "hub-6", "hub-7"];
        const hubHeightMap = new Map<string, number>();
        const hubBeforeHeightMap = new Map<string, number>();
        //document.ready
        $(() => {
            forEach(hubIds, (id) => {
                const expandable = document.getElementById(id);
                const expandableContent = expandable.querySelector('.expandable-content') as HTMLElement;
                expandableContent.style.display = 'block';
                hubHeightMap.set(id, expandableContent.clientHeight);
                expandableContent.style.display = 'none';
                hubBeforeHeightMap.set(id, expandable.clientHeight);
            });

            this.hubHeightMap = hubHeightMap;
            this.hubBeforeHeightMap = hubBeforeHeightMap;
        });

    }

    expandHub(id: string): void {
        const expandable = document.getElementById(id);
        const expandableContent = expandable.querySelector('.expandable-content') as HTMLElement;
        const expandableIcon = expandable.querySelector('.expand-btn') as HTMLElement;
        expandableIcon.style.transform = expandableContent.classList.contains('expanded') ? 'rotateX(0deg)' : 'rotateX(180deg)';
        const heightChange = this.hubHeightMap.get(id);
        const beforeHeight = this.hubBeforeHeightMap.get(id);
        if (expandableContent.classList.contains('expanded')) {
            expandableContent.classList.remove('expanded');
            //expandable.style.height = beforeHeight + 'px';
            //console.log("contract");
            //console.log(expandable.clientHeight);
            //console.log(expandableContent.clientHeight);
            expandableContent.style.visibility = 'hidden';
            expandableContent.style.opacity = '0';
            expandableContent.style.display = 'none';
        } else {
            expandableContent.classList.add('expanded');
            expandableContent.style.display = 'block';
            expandableContent.style.visibility = 'hidden';
            expandableContent.style.opacity = '0';

            setTimeout(() => {
                expandableContent.style.visibility = 'visible';
                expandableContent.style.opacity = '1';
            }, 100);

            //expandable.style.height = beforeHeight + heightChange + 10 + 'px';

            //console.log("expand");
            //console.log(expandable.clientHeight);
            //console.log(expandableContent.clientHeight);
        }

    }

}
